<template>

  <div id="content" :class="[$route.name, ((isLogged) ? 'logged' : '')]">
    <router-view />
  </div>

</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        isLogged: this.$store.getters['login/isLogged'],
      }
    },
    computed: {
      section() {
        return this.$store.getters.section
      },
    },
    methods: {
      addMainClass() {
        document.body.setAttribute("class", "")
        if (this.section) {
          document.body.classList.add(this.section)
        } else {
          document.body.classList.add('login')
        }
        if (global.isOffline) {
          document.body.classList.add('offline')
        } else {
          document.body.classList.add('online')
        }
      },
      closeApp() {
        this.$store.dispatch('closeMainWindow')
      },
    },
    created() {
      console.log("APP CREATED")
      if (this.$route !== '/') this.$router.push('/')
    },
    mounted() {
      //console.log("APP MOUNTED")
    },
    updated() {
      //console.log("APP UPDATED")
      this.addMainClass()
    },
  }
</script>

<style>
</style>
